var ECommentType;

(function (ECommentType) {
  /* eslint-disable no-magic-numbers */
  ECommentType[ECommentType["Sound"] = 1] = "Sound";
  ECommentType[ECommentType["Album"] = 2] = "Album";
  ECommentType[ECommentType["News"] = 3] = "News";
  ECommentType[ECommentType["Channel"] = 4] = "Channel";
  ECommentType[ECommentType["Topic"] = 6] = "Topic";
  ECommentType[ECommentType["Event"] = 7] = "Event";
  /* eslint-enable no-magic-numbers */
})(ECommentType || (ECommentType = {}));

var ESortType;

(function (ESortType) {
  ESortType[ESortType["ByPublishTime"] = 1] = "ByPublishTime";
  ESortType[ESortType["ByNumSubComments"] = 2] = "ByNumSubComments"; // eslint-disable-next-line no-magic-numbers

  ESortType[ESortType["ByPopularity"] = 3] = "ByPopularity";
})(ESortType || (ESortType = {}));

export { ECommentType, ESortType };
